<template>
    <div class="score-history__item">
        <div class="column"><div class="withdrawal-of-funds">{{item.transactionMeta.label}}</div></div>
        <div class="column"> {{ item.createdAt }}</div>
        <div class="column"></div>
        <div class="column"><div class="withdrawal-of-funds-amount"> {{ (item.amount * item.transactionMeta.sign).toFixed(2) }}</div></div>
        <div class="column"> {{ item.currentAmount }}</div>
        <div class="column plug"></div>
        <div class="column plug"></div>
        <div class="column"><span>Джерело:</span> {{item.transactionMeta.source}}</div>
        <div class="column"><span>ID транзакції:</span> {{ item.id }}</div>
    </div>
</template>

<script>
export default {
    name: 'RowBlockWithdrawalOfFunds',
    props: {
        item: {
            type: Object,
            default: () => {
                return {
                    id: null,
                    amount: null,
                    createdAt: null,
                    currentAmount: null,
                };
            },
        },
    },
}
</script>
